export const normalizeEmail = (e: string | null | undefined): string =>
  (e ?? "").toLowerCase().trim();

export const emailEquals = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => {
  const normalized = normalizeEmail(a);

  return normalized !== "" && normalized === normalizeEmail(b);
};

/** Drops case-insensitive repeats, keeping each address's first spelling. */
export const uniqueEmails = (emails: string[]): string[] => {
  const seen = new Set<string>();
  return emails.filter((email) => {
    const key = normalizeEmail(email);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
